import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/node_modules/next/font/google/target.css?{\"path\":\"src/app/(home-form)/layout.tsx\",\"import\":\"Barlow\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\",\"900\"],\"display\":\"swap\"}],\"variableName\":\"barlow\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs-sg/src/components/forms/careerForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs-sg/src/components/forms/generalForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs-sg/src/components/forms/homepageForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs-sg/src/components/forms/resourceForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs-sg/src/components/forms/servicesForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs-sg/src/components/googleCaptchaWrapper.tsx");
